import { Link } from 'react-router-dom'
import logo from '../logo.jpg'
import { isPhone } from '../common/constants'

interface Props {
  shrink?: boolean
}

export function Logo({ shrink = false }: Props) {
  return isPhone ? null : (
    <div
      className={`flex items-center flex-shrink-0 text-white mr-6
    h-[${shrink ? '30px' : '150px'}]`}
    >
      <Link to="/">
        <img src={logo} className="app-logo" alt="logo" />
      </Link>
    </div>
  )
}
